<template>
    <div class="lo router">
        <loPage>
            <loAside ref="loAside">
                <mdCaption
                    :caption="$t('site.noun.userprofile')"
                ></mdCaption>
                <mdNav
                    :data="navTree"

                    @sendEvent="receiveEvent"
                ></mdNav>
            </loAside>
            <loSection>
                <loArticle>
                    <mdCartCaption
                        :caption="caption"
                    ></mdCartCaption>
                    <component
                        :is="page"

                        @sendEvent="receiveEvent"
                    ></component>
                    <mdNavToggle></mdNavToggle>
                </loArticle>
            </loSection>
        </loPage>
    </div>
</template>

<script>
    import loPage from '@/components/loPage'
    import loHeading from '@/components/loHeading'
    import loSection from '@/components/loSection'
    import loArticle from '@/components/loArticle'
    import loAside from '@/components/loAside'
    import mdNav from '@/components/mdNav'
    import mdCaption from '@/components/mdCaption'
    import mdCartCaption from '@/components/mdCartCaption'
    import mdNavToggle from '@/components/mdNavToggle'
    import purchase from '@/components/pgPurchase'
    import profile from '@/components/pgProfile'
    import statistical from '@/components/pgStatistical'
    import favorite from '@/components/pgFavorite'
    import notification from '@/components/pgNotification'

    export default {
        components: {
            loPage,
            loHeading,
            loSection,
            loArticle,
            loAside,
            mdNav,
            mdCaption,
            mdCartCaption,
            mdNavToggle,
            purchase,
            profile,
            statistical,
            favorite,
            notification,
        },
        data: function(){

            return {
                navData: {
                    purchase: this.$t('page.userprofile.item.myorders'),
                    profile: this.$t('page.userprofile.item.myaccount'),
                    statistical: this.$t('page.userprofile.item.mypurchases'),
                    favorite: this.$t('page.userprofile.item.myfavorites'),
                    notification: this.$t('page.userprofile.item.notification'),
                },
            }
        },
        computed: {
            query: function(){
                return this.$route.query || {}
            },
            navTree: function(){
                let $result = [],
                    $navData = this.navData,
                    _page = this.page;

                for( let _key in $navData ) {

                    $result.push({
                        sn: _key,
                        caption: $navData[_key],
                        // href: '/system/account?page='+ _key,
                        active: _page === _key,
                    });
                }

                return $result;
            },
            page: function(){
                return this.query.page || 'purchase';

                //purchase 訂單總覽
                //profile 帳號資料
                //statistical 統計資料
                //favorite 商品收藏
            },
            tab: function(){
                return this.query.tab || '0';

                //inquery 詢價單
                //quotation 報價單
                //pendingOrder 訂單確認中
                //comfirmedOrder 訂單已成立
                //cancel 已取消
            },
            caption: function(){
                let $navTree = this.navTree,
                    _page = this.page;

                let _result = '';

                let $target = $navTree.find(item => item.sn === _page);

                if( $target && $target.caption ) {
                    _result = $target.caption;
                }
                    
                return _result;
            }
        },
        methods: {
            clickNav: function(opt){
                this.$router.push('/system/account?page='+ opt.sn);
                this.$refs.loAside.changeState();
            },
        }
    }
</script>

<style scoped lang="scss">

</style>
